<template>
    <div class="credit-card-section">
        <div id="customCard-container" v-if="readOnly && selectedPaymentMethod.cardData">
            <div class="vue-form">
                <div class="vue-form-row">
                    <div class="vue-form-element">
                        <label>
                            <span class='cardHolderName'>{{holderName}}</span>
                            <span>{{lastFour}}</span>
                            <span>{{expiryDate}}</span>
                        </label>
                    </div>
                </div>
                <div class="vue-form-row">
                    <div class="vue-form-element half-width">
                        <label>
                            <span class="field-label">
                               {{resources.creditCards.cvc}}
                                <span class="field-help">
                                    <span>{{resources.creditCards.cvcHelpText}}</span>
                                </span>
                            </span>
                            <span v-if="cvcInvalid" class="error" id="encryptedSecurityCode-error">{{resources.errors.invalidInput}}</span>
                            <div data-cse="encryptedSecurityCode" class="input-wrapper">
                                <span class="icon icon-card-payment"></span>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div id="customCard-container" v-else>
            <div class="vue-form">
                <div class="vue-form-row">
                    <div class="vue-form-element">
                        <label>
                            <span>{{resources.creditCards.number}}</span>
                            <span v-if="cardNumberInvalid" class="error" id="encryptedCardNumber-error">{{resources.errors.invalidInput}}</span>
                            <div data-cse="encryptedCardNumber" class="input-wrapper">
                                <img class="brand-logo" :src="brandImageUrl" />
                            </div>
                        </label>
                    </div>
                </div>

                <div class="vue-form-row has-multiple-elements">
                    <div class="vue-form-element">
                        <label>
                            <span>{{resources.creditCards.expiryDate}}</span>
                            <span v-if="expiryDateInvalid" class="error" id="encryptedExpiryDate-error">{{resources.errors.invalidInput}}</span>
                            <div data-cse="encryptedExpiryDate" class="input-wrapper"></div>
                        </label>
                    </div>
                    <div class="vue-form-element">
                        <label>
                            <span class="field-label">
                                {{resources.creditCards.cvc}}
                                <span class="field-help">
                                    <span>{{resources.creditCards.cvcHelpText}}</span>
                                </span>
                            </span>
                            <span v-if="cvcInvalid" class="error" id="encryptedSecurityCode-error">{{resources.errors.invalidInput}}</span>
                            <div data-cse="encryptedSecurityCode" class="input-wrapper">
                                <span class="icon icon-card-payment"></span>
                            </div>
                        </label>
                    </div>
                </div>

                <div class="vue-form-row">
                    <div class="vue-form-element half-width">
                        <label>
                            <span>{{resources.creditCards.holderName}}</span>
                            <span v-if="!isValidCardHolderName" class="error" id="cardHolderName-error">{{resources.errors.invalidInput}}</span>
                            <input type="text" id="cardHolderName" @input="allowWordsOnly" @keypress="allowWordsOnly" @focus="allowWordsOnly" @blur="allowWordsOnly"  @change="updatePaymentData"/>
                        </label>
                    </div>
                </div>

                <div class="vue-form-row no-label" v-show="showSaveOption">
                    <div class="vue-form-element">
                        <div class="vue-form-group">
                            <div class="vue-form-group-item">
                                <input type="checkbox" class="vue-input vue-input-checkbox" id="saveCreditCard" @change="updatePaymentData"/>
                                <label for="saveCreditCard">{{resources.creditCards.saveCard}}</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="supportedCoBrands && supportedCoBrands.length > 0" id="pmWrapperDual" class="vue-form-row co-branded-cards">
                    <div class="vue-form-element">
                        <div @click="dualBrandListener" :data-value="element.brand" v-for="element in supportedCoBrands" class="vue-form-group-item">
                            <input
                                class="vue-input vue-input-radio"
                                type="radio"
                                :checked="element.selected"
                                :data-value="element.brand"
                            />
                            <label :data-value="element.brand">
                                <img :src="element.brandImageUrl" :data-value="element.brand" :alt="element.brand" class="brand-logo"/>
                                <span :data-value="element.brand">{{element.localeBrand}}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script src='./credit-cards.js'></script>
